<template lang="pug">
v-container(fluid pa-0 ma-0)
  template(v-if="item")
    v-card(
      outlined
      :ripple="false"
      :to="{ name: 'goodsItem', params: { id: item.id } }"
      class="tw-mb-2 tw-cursor-pointer  tw-border-gray-200"
    )
      div(class="tw-w-full")
        v-row(dense)
          v-col(cols="12" md="5")
            v-img(:src="path(item.main_image.path)" aspect-ratio="1.5" class=" k-listing-card-image")
          v-col(class="tw-my-2")
            v-row(no-gutters class=" tw-px-4 md:tw-px-0")
              v-col
                div
                  router-link(class="tw-font-bold text-link tw-text-lg" :to="{ name: 'goodsItem', params: { id: item.id } }") {{ item.name }}
                div(class="pt-1")
                  router-link(class="tw-font-medium text-link" :to="{ name: 'goodsItem', params: { id: item.id } }") {{ item.address_city }}, {{ item.address_zip_code }}
              v-col(cols="auto")
                v-chip(outlined color="indigo lighten-2" class="mr-2 tw-font-bold")
                  span {{ item.pivot.type }}
            v-divider(class="mt-6 mb-4  ")
            v-row(no-gutters justify="start" align-self="end" class=" tw-px-4 md:tw-px-2")
              v-col(cols="auto" class=" tw-items-center ")
                v-row(no-gutters justify="center" class="")
                  v-col(v-if="item.bedrooms" class="tw-mr-2")
                    v-row(no-gutters align="center" justify="center")
                      v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                        span {{ item.bedrooms }}
                      v-col(cols="auto" class=" tw-text-center")
                        v-icon mdi-bed
                    v-row(no-gutters)
                      v-col(cols="auto" class=" tw-text-center tw-text-xs tw-capitalize")
                        | {{ $t('Listings.Common.bedrooms') }}
                  v-col(v-if="item.bathrooms" class="tw-mr-2")
                    v-row(no-gutters align="center" justify="center")
                      v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                        span {{ item.bathrooms }}
                      v-col(cols="auto" class=" tw-text-center")
                        v-icon mdi-shower
                    v-row(no-gutters)
                      v-col(class=" tw-text-center tw-text-xs tw-capitalize")
                        | {{ $t('Listings.Common.bathrooms') }}
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.k-listing-card-image {
  border-radius: 12px 0 0 12px;

  @media screen and (max-width: 768px) {
    border-radius: 12px 12px 0 0;
  }
}
</style>
